export function formatAmount(amount: number | string, currency: string) {
  const numericAmount = Number(amount);
  const locale = window.navigator.language;

  if ((Boolean(amount) || numericAmount === 0) && !isNaN(numericAmount)) {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
    }).format(numericAmount);
  }
  return "-";
}
